import CitySEOHead from "@/components/feature/CitySEOHead";
import AventuraHeroSection from "./components/HeroSection";
import AventuraStickyNav from "./components/StickyNav";
import AventuraProcessingTimeSection from "./components/ProcessingTimeSection";
import AventuraServicesSection from "./components/ServicesSection";
import AventuraLocalAreaSection from "./components/LocalAreaSection";
import AventuraTravelTimingSection from "./components/TravelTimingSection";
import AventuraDestinationsSection from "./components/DestinationsSection";
import AventuraTestimonialsSection from "./components/TestimonialsSection";
import AventuraAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AventuraComparisonSection from "./components/ComparisonSection";
import AventuraMistakesSection from "./components/MistakesSection";
import AventuraHowItWorksSection from "./components/HowItWorksSection";
import AventuraFAQSection, { faqs } from "./components/FAQSection";
import AventuraHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AventuraFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const aventuraServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AventuraPage() {
  return (
    <>
      <CitySEOHead
        city="Aventura"
        state="Florida"
        stateAbbr="FL"
        route="/cities/aventura"
        title="Emergency Passport Aventura, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Aventura, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade and Broward County travelers."
        ogTitle="Emergency Passport Aventura, FL — Expedited & Fast Passport Service | Fast Passport Center"
        ogDescription="Emergency and expedited passport services in Aventura, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade and Broward County travelers."
        twitterTitle="Emergency Passport Aventura, FL — Expedited & Fast Passport Service | Fast Passport Center"
        twitterDescription="Emergency and expedited passport services in Aventura, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Miami-Dade and Broward County travelers."
        geoPlacename="Aventura, Florida"
        geoPosition="25.9565;-80.1392"
        keywords="expedited passport Aventura, emergency passport Aventura FL, same day passport Aventura, fast passport South Florida, passport renewal Aventura, Aventura passport courier"
        faqs={faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }))}
        servicesSchema={aventuraServices}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
      />
      <div className="font-sans">
        <AventuraHeroSection />
        <AventuraStickyNav />
        <AventuraProcessingTimeSection />
        <AventuraServicesSection />
        <AventuraLocalAreaSection />
        <AventuraTravelTimingSection />
        <AventuraDestinationsSection />
        <AventuraTestimonialsSection />
        <AventuraAcceptanceFacilitiesSection />
        <AventuraComparisonSection />
        <AventuraMistakesSection />
        <AventuraHowItWorksSection />
        <AventuraFAQSection />
        <AventuraHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/aventura" state="FL" />
        <AventuraFinalCTA />
      </div>
    </>
  );
}